import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import React from 'react'

type Props = {
  title: string
  date: string
}

const Header = ({ title, date }: Props) => {
  return (
    <Box p={2}>
      <Typography fontWeight={'500'} variant="h6">
        {title}
      </Typography>
      <Typography variant="caption">{date}</Typography>
    </Box>
  )
}

export default Header
